module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      active: _vm.active
    },
    style: ({
      height: _vm.window_height
    }),
    attrs: {
      "id": "cards_mobile"
    }
  }, [_c('img', {
    attrs: {
      "id": "card_slider_logo",
      "src": require("../assets/img/card_slider_logo.svg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_vm._l((_vm.cards), function(card) {
    return _c('div', {
      staticClass: "swiper-slide"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'card_open',
          params: {
            card_number: card.fields.cardNumber
          }
        }
      }
    }, [_c('div', {
      staticClass: "slide_card",
      class: [card.fields.cardType.toLowerCase(), {
        disclaimer: card.fields.disclaimer
      }]
    }, [(card.fields.image) ? _c('div', {
      staticClass: "slide_card_image",
      style: ({
        'background-image': 'url(' + card.fields.image + ')'
      })
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "slide_content_layer"
    }, [_c('p', {
      staticClass: "slide_card_number"
    }, [_vm._v(_vm._s(_vm._f("card_number")(card.fields.cardNumber)))]), _vm._v(" "), _c('div', {
      staticClass: "slide_card_content"
    }, [_c('p', {
      staticClass: "slide_card_title card_title"
    }, [_vm._v(_vm._s(card.fields.cardTitle))]), _vm._v(" "), (card.fields.sponsored) ? _c('p', {
      staticClass: "slide_card_sponsored"
    }, [_vm._v("presented by toyota c-hr")]) : _vm._e(), _vm._v(" "), _c('p', {
      staticClass: "slide_card_teaser"
    }, [_vm._v(_vm._s(card.fields.cardTeaserCopy))])]), _vm._v(" "), _c('router-link', {
      staticClass: "slide_card_button",
      attrs: {
        "to": {
          name: 'card_open',
          params: {
            card_number: card.fields.cardNumber
          }
        }
      },
      on: {
        "click": function($event) {
          _vm.mobile_ga(card.fields.cardNumber)
        }
      }
    }, [_c('button', [_vm._v("learn more")])]), _vm._v(" "), (card.fields.cardType.toLowerCase() == 'do') ? _c('img', {
      staticClass: "slide_card_icon",
      attrs: {
        "src": require("../assets/img/do.svg")
      }
    }) : (card.fields.cardType.toLowerCase() == 'listen') ? _c('img', {
      staticClass: "slide_card_icon",
      attrs: {
        "src": require("../assets/img/listen.svg")
      }
    }) : (card.fields.cardType.toLowerCase() == 'make') ? _c('img', {
      staticClass: "slide_card_icon",
      attrs: {
        "src": require("../assets/img/make.svg")
      }
    }) : (card.fields.cardType.toLowerCase() == 'buy') ? _c('img', {
      staticClass: "slide_card_icon",
      attrs: {
        "src": require("../assets/img/buy.svg")
      }
    }) : _c('img', {
      staticClass: "slide_card_icon",
      attrs: {
        "src": require("../assets/img/watch.svg")
      }
    }), _vm._v(" "), (card.fields.disclaimer) ? _c('p', {
      staticClass: "slide_card_sponsored disclaimer"
    }, [_vm._v(_vm._s(card.fields.disclaimer))]) : _vm._e()], 1)])])], 1)
  }), _vm._v(" "), _vm._m(0)], 2), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.card_swiper.isBeginning),
      expression: "!card_swiper.isBeginning"
    }],
    staticClass: "swiper-prev fa fa-chevron-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.card_swiper.isEnd),
      expression: "!card_swiper.isEnd"
    }],
    staticClass: "swiper-next fa fa-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "card_slider_progress"
    }
  }, [_c('div', {
    attrs: {
      "id": "progress_bar"
    }
  }), _vm._v(" "), _c('div', {
    style: ({
      left: _vm.progress_point_position
    }),
    attrs: {
      "id": "progress_point"
    },
    on: {
      "touchmove": _vm.slide_progress
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "legal",
    attrs: {
      "id": "card_slider_legal"
    }
  }, [_c('p', {
    staticClass: "copyright"
  }, [_vm._v("© 2016 REFINERY29")]), _vm._v(" "), _c('p', [_vm._v("BY USING OUR SERVICE, YOU AGREE TO OUR "), _c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "http://www.refinery29.com/terms-and-conditions",
      "target": "_blank"
    }
  }, [_vm._v("TERMS")]), _vm._v(" (EFFECTIVE 2/07/2017) AND "), _c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "http://www.refinery29.com/privacy",
      "target": "_blank"
    }
  }, [_vm._v("PRIVACY")]), _vm._v(" (EFFECTIVE 2/07/2017).")]), _vm._v(" "), _c('p', [_vm._v("REFINERY29 NAME & LOGO AND R29 LOGO ARE TRADEMARKS OF REFINERY 29 INC.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-595ef270"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cards-mobile.vue
// module id = 50
// module chunks = 0